
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as PlusSquare } from "bootstrap-icons/icons/plus-square.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CheckCircleFill } from "bootstrap-icons/icons/check-circle-fill.svg";
import { ReactComponent as LightningChargeFill } from "bootstrap-icons/icons/lightning-charge-fill.svg";
import { ReactComponent as DeleteFlashIcon } from "bootstrap-icons/icons/trash.svg";
import { ReactComponent as EditFlashIcon } from "bootstrap-icons/icons/pencil.svg";

import { ReactComponent as PlusCircleFill } from "bootstrap-icons/icons/plus-circle-fill.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
// import { ReactComponent as Calendar } from "bootstrap-icons/icons/calendar.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";

import { useState, useEffect, useContext } from "react";
import Spinner from "../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../components/utils/CustomStyles";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";
import { handleError } from "../../components/utils/AuthenticationCheck";
// import DropDownMenu from "../flashSales/dropdownForproductRow/DropDownMenu";
import { AuthContext } from "../../AuthProvider/AuthProvider";
import formatDate from "../../components/utils/DateFormatter";
import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";

const PendingproductRowList = () => {
  const [productRowList, setproductRowList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const { permissions } = useContext(AuthContext);
  // console.log("this is permissions", permissions);

  // Date filter state
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };


  // Clear date filters
  const handleClearDates = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };
  // Check if both dates are selected
  const areDatesSelected = filters.start_date && filters.end_date;
  const navigate = useNavigate();

  // Fetch product stock
  useEffect(() => {
    const fetchproductRowList = async () => {
      setLoading(true);
      try {
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) {
          throw new Error("No access token found.");
        }

        const response = await axios.get(ApiServices.pendingProductStock, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message, data } = response.data;
        //  console.log("this is all pending product stock list", data);
        if (status === 200) {
          // const activeproductRow = data.filter(
          //   (product) => product.product_status === "active"
          // );
          // console.log("this is all product stock list", activeproductRow);
          //console.log("Active Product Stock:", activeproductRow);
          // setproductRowList(activeproductRow.slice().reverse());
          setproductRowList(data);
          toast.success(message, { toastId: "product-stock-fetch-success" });
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchproductRowList();
  }, [navigate]);

  // Filter data by name
  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Function to format permission text
  const formatText = (text) => {
    let formattedText = text.replace(/_/g, " ");
    formattedText = formattedText
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
    return formattedText;
  };

  const ExpandableComponent = ({ data }) => {
    const approved = data?.approved ?? null;
    const superApproval = data?.super_approval ?? null;

    // Determine if any buttons should be shown
    const showFirstApproval = approved === 0 || approved === null;
    const showSecondApproval = (superApproval === 0 || superApproval === null) && (approved === 1 || approved === 2);

    // Return null if no buttons should be shown
    if (!showFirstApproval && !showSecondApproval) {
      return null;
    }

    return (
      <div className="flex justify-start px-2 relative">
        {/* Stock Details, Edit, and Additions */}
        {permissions.some(permission => permission.name === 'stock.view') && (
          <div className="relative mx-2 my-2 group">
            <Link
              to="/admin/products/stock/pending/details"
              state={{ stock_id: data.stock_id, productStock: data }}
            >
              <Eye className="w-5 h-5 text-darkGreen3" />

            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
              Details
            </div>
          </div>
        )}
        {/* First Approval Button */}
        {showFirstApproval && (
          <div className="relative mx-2 my-2 group">
            <Link
              to="/admin/product/stock/approval"
              state={{ productRow: data }}

            >
              <CheckCircleFill className="w-5 h-5 text-darkGreen2" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                First Approval
              </div>
            </Link>
          </div>
        )}

        {/* Second Approval Button */}
        {showSecondApproval && (
          <div className="relative mx-2 my-2 group">
            <Link
              to="/admin/product/stock/second/approval"
              state={{ productRow: data }}
            >
              <CheckCircleFill className="w-5 h-5 text-dash4" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash5 text-xs whitespace-nowrap">
                Second Approval
              </div>
            </Link>
          </div>
        )}
      </div>
    );
  };

  const columns = [

    {
      name: "Name",
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.name ? row.name.toUpperCase() : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md  text-xs bg-orange1 text-lGrey2">
            {row.sku ? row.sku.toLowerCase() : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Price",
      selector: (row) => CurrencyFormatter(row.price),
      sortable: true,
      width: "180px",
    },
    {
      name: "Qty",
      selector: (row) => row.quantity,
      sortable: true,
      width: "100px",
    },

    {
      name: "Aval.Qty",
      selector: (row) => row.avail_quantity,
      sortable: true,
      width: "100px",
    },
    {
      name: "Profit",
      selector: (row) => `${row.discount_percentage}%`,
      sortable: true,
      width: "100px",
    },
    {
      name: "Product Owner",
      selector: (row) => (row.store_id ? row.store_id : "NOT AVAILABLE"),
      sortable: true,
      cell: (row) => {
        let backgroundColor = "grey";
        let text = "NOT AVAILABLE";

        if (row.store_id === 1) {
          backgroundColor = "#1D9E34";
          text = "Admin";
        } else if (row.store_id && row.store_id !== 1) {
          backgroundColor = "#4373fc";
          text = "Vendor";
        }

        return (
          <span
            style={{
              backgroundColor: backgroundColor,
              color: "white", // so the text is readable
              padding: "5px 10px",
              borderRadius: "5px",
              display: "inline-block",
            }}
          >
            {text}
          </span>
        );
      },
      width: "180px",
    },

    // {
    //   name: "Product Status",
    //   selector: (row) =>
    //     row.product_status ? row.product_status.toUpperCase() : "NOT AVAILABLE",
    //   sortable: true,
    //   cell: (row) => {
    //     let color = "grey";

    //     if (row.product_status === "active") {
    //       color = "green";
    //     } else if (row.product_status === "inactive") {
    //       color = "red";
    //     }

    //     return (
    //       <span style={{ color: color }}>
    //         {row.product_status
    //           ? row.product_status.toUpperCase()
    //           : "NOT AVAILABLE"}
    //       </span>
    //     );
    //   },
    //   width: "150px",
    // },
    {
      name: "Status",
      selector: (row) =>
        row.status ? row.status.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => {
        let color = "pending";

        if (row.status === "pending") {
          color = "red";
        }

        return (
          <span style={{ color: color }}>
            {row.status
              ? row.status.toUpperCase()
              : "NOT AVAILABLE"}
          </span>
        );
      },
      width: "150px",
    },
    {
      name: "Date",
      selector: (row) => row.created_at ? formatDate(row.created_at) : "NOT AVAIALABLE",
      sortable: true,
      width: "200px",
    },

  ];


  //filter data
  const filteredItems = productRowList.filter((item) => {
    const matchesFilterText = Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(filterText.toLowerCase())
    );


    // Filter data based on date range
    let matchesDateRange = true;
    if (areDatesSelected) {
      const itemDate = new Date(item.created_at);
      const startDate = new Date(filters.start_date);
      const endDate = new Date(filters.end_date);

      // Set time to end of day for end date
      endDate.setHours(23, 59, 59, 999);

      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesDateRange;
  });

  const data = filteredItems.map((productRow) => ({
    last_restocked_at: productRow.last_restocked_at || "NOT AVAILABLE",
    price: productRow.price || "0.00",
    quantity: productRow.quantity || "0",
    product_category: productRow.product_category || "NOT AVAILABLE",
    sub_category: productRow.sub_category || "NOT AVAILABLE",
    status: productRow.status || "NOT AVAILABLE",
    category: productRow.category
      ? productRow.category.toUpperCase()
      : "NOT AVAILABLE",
    sub_category_id: productRow.sub_category_id,
    category_id: productRow.category_id,
    name: productRow.name,
    product_category_id: productRow.product_category_id,
    product_status: productRow.product_status,
    sku: productRow.sku,
    stock_id: productRow.stock_id,
    store_id: productRow.store_id,
    store_name: productRow.store_name ? productRow.store_name.toUpperCase() : "NOT AVAILABLE",
    product_id: productRow.product_id,
    flash_sale: productRow.flash_sale,
    flash_sale_id: productRow.flash_sale_id,
    quantity: productRow.quantity,
    sold_quantity: productRow.sold_quantity,
    avail_quantity: productRow.avail_quantity,
    discount_percentage: productRow.discount_percentage,
    is_serialized: productRow.is_serialized,
    approved: productRow.approved,
    super_approval: productRow.super_approval,
    created_at: productRow.created_at,
  }));

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });


  // Handle CSV Download - Server-side filtered by date
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(filters.start_date);
    const endDate = new Date(filters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload
      const downloadPayload = {
        start_date: filters.start_date,
        end_date: filters.end_date,
        download: 1,
      };

      // Create filename with date range
      const startDateFormatted = filters.start_date.replace(/-/g, '_');
      const endDateFormatted = filters.end_date.replace(/-/g, '_');
      const filename = `pending_product_stock_${startDateFormatted}_to_${endDateFormatted}.csv`;

      // Call the download function
      await downloadCSVFromApi(
        ApiServices.pendingProductStock,
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [], // Add sensitive columns to exclude 
          maxRows: 50000
        }
      );

    } catch (error) {
      console.error("Download error:", error);
      handleError(error, navigate);
      // Additional download-specific error messages
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };


  return (
    <div>
      <MainLayouts>
        <div className=" sm:rounded-lg py-6 w-full">
          <section
            className="w-full pr-[3%] pt-3 my-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Pending Stock Product
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>

          <div className="pb-4 bg-white dark:bg-gray-900">
            {/* DESKTOP FILTERS (md and up) - All in one row */}
            <div className="hidden md:flex flex-wrap items-center gap-3">
              <div className="relative flex-grow min-w-[200px]">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              <div className="min-w-[150px]">
                <div className="relative">
                  {/* <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" /> */}
                  <input
                    type="date"
                    value={filters.start_date}
                    onChange={(e) => handleFilterChange("start_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    max={filters.end_date || undefined}
                    placeholder="Start Date"
                  />
                </div>
              </div>

              <div className="min-w-[150px]">
                <div className="relative">
                  {/* <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" /> */}
                  <input
                    type="date"
                    value={filters.end_date}
                    onChange={(e) => handleFilterChange("end_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    min={filters.start_date || undefined}
                    placeholder="End Date"
                  />
                </div>
              </div>

              {areDatesSelected && (
                <div className="min-w-[120px]">
                  <button
                    onClick={handleClearDates}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear Dates
                  </button>
                </div>
              )}

              <div className="min-w-[160px]">
                <button
                  onClick={handleDownloadCSV}
                  className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
                    ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  disabled={!areDatesSelected || loadingCSV}
                  title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
                >
                  {loadingCSV ? (
                    <>
                      <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                      Downloading...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      Download CSV
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* MOBILE FILTERS (below md) - Stacked */}
            <div className="md:hidden flex flex-col gap-3">
              {/* Search - Full width */}
              <div className="w-full">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Dates and buttons in a grid on mobile */}
              <div className="grid grid-cols-2 gap-3">
                {/* Start Date */}
                <div className="col-span-1">
                  <div className="relative">
                    {/* <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" /> */}
                    <input
                      type="date"
                      value={filters.start_date}
                      onChange={(e) => handleFilterChange("start_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      placeholder="Start"
                    />
                  </div>
                </div>

                {/* End Date */}
                <div className="col-span-1">
                  <div className="relative">
                    {/* <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" /> */}
                    <input
                      type="date"
                      value={filters.end_date}
                      onChange={(e) => handleFilterChange("end_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      placeholder="End"
                    />
                  </div>
                </div>

                {/* Clear Dates Button - Full width when shown */}
                {areDatesSelected && (
                  <div className="col-span-2">
                    <button
                      onClick={handleClearDates}
                      className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
                    >
                      <XCircle className="w-4 h-4" />
                      Clear Dates
                    </button>
                  </div>
                )}

                {/* Download Button - Full width */}
                <div className="col-span-2">
                  <button
                    onClick={handleDownloadCSV}
                    className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
                      ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    disabled={!areDatesSelected || loadingCSV}
                  >
                    {loadingCSV ? (
                      <>
                        <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                        <span className="ml-2">Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4" />
                        <span className="ml-2">Download CSV</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* DESKTOP help text (md and up) */}
            <div className="hidden md:flex items-center justify-between mt-2">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600">
                  Showing {sortedData.length} records from {filters.start_date} to {filters.end_date}
                </p>
              )}
            </div>

            {/* MOBILE help text (below md) */}
            <div className="md:hidden mt-3">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500 text-center mb-2">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600 text-center">
                  Showing {sortedData.length} records
                </p>
              )}
            </div>
          </div>





          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={<div>No Product found</div>}
              expandableRows={sortedData.some(item => {
                const approved = item.approved ?? null;
                const superApproval = item.super_approval ?? null;
                const showFirst = approved === 0 || approved === null;
                const showSecond = (superApproval === 0 || superApproval === null) && (approved === 1 || approved === 2);
                return showFirst || showSecond;
              })}
              expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default PendingproductRowList;
